import React, { Fragment, useContext, useMemo, useState } from "react";
import { FormDataFeild } from "../../../../reuseable/Inputs";
import { useMutation, useQuery } from "react-query";
import { DELETE_IMAGE, Upload_Image } from "../../../../Apis/userApi/UserApi";
import { Dialog } from "primereact/dialog";
import {
  handleInfiniteScroll,
  IsLoadingResponse,
  ToastMessage,
} from "../../../../utils/Helper";
import "cropperjs/dist/cropper.css";
import {
  Submit,
  TYPE_FELDS,
  FileType,
  NOT_FOUND_IMAGE,
  DROPDOWN_CLASS,
  Post_Type,
  UpdateCustomerPostTitle,
  CreateCustomerPostTitle,
} from "../../../../constants";
import { Button } from "primereact/button";
import { Col, Form, Row } from "react-bootstrap";
import { Card, CardBody } from "reactstrap";
import { createCustomerPostSchema } from "../../../../utils/validationSchema";
import CropImagePopup from "../../../CropImagePopup";
import SweetConfirmation from "../../../../reuseable/sweetConfirmation";
import { get_Customer } from "../../../../Apis/customerApi/customerApi";
import CustomerPostContext from "../../../../context/CustomerPostContext /CustomerPostContext ";
import {
  Create_Customer_Post,
  Put_Update_Customer_Post,
} from "../../../../Apis/customerPostApi/customerPostApi";
import { InputSwitch } from "primereact/inputswitch";

const CustomerPostCreateFormPopup = (props) => {
  const {
    setFormData,
    orgId,
    isEdit,
    setDialogs,
    formData,
    dialog,
    errors,
    setErrors,

    crop,
    setCrop,
    completedCrop,
    setCompletedCrop,
    scale,
    rotate,
    aspect,
  } = useContext(CustomerPostContext);
  const { handleOpenandClosePopup, refetch, emptyData } = props;
  const [dialogModal, setdialogsModal] = useState(false);
  const [customerDrop, setCustomerDrop] = useState({
    data: [],
    totalRecords: "",
    pageNumber: 1,
    nameFilter: "",
  });

  /**
   *
   * @param {event } e
   * create Customer & update Customer
   */

  const { mutate: createCustomerPost, isLoading: createCompanyLoader } =
    useMutation((formData) => Create_Customer_Post(formData), {
      onSuccess: (response) => {
        if (response.status === 200) {
          refetch();
          setDialogs(false);
          emptyData();
          setErrors({});
          ToastMessage(response.status, response.data.message);
        }
      },
    });

  const { mutate: updateCustomerPost, isLoading: updateCompanyLoader } =
    useMutation((formData) => Put_Update_Customer_Post(formData, orgId), {
      onSuccess: (response) => {
        if (response.status === 200) {
          refetch();
          setDialogs(false);
          emptyData();
          setErrors({});
          ToastMessage(response.status, response.data.message);
        }
      },
    });

  const handleCustomerCreateAndUpdate = async (e) => {
    e.preventDefault();
    try {
      let schema = createCustomerPostSchema();
      await schema.validate(formData, { abortEarly: false });
      if (orgId !== -1 && isEdit === false) {
        let value = {
          ...formData,
          url: formData?.image
            ? formData?.image.split(process.env.REACT_APP_FILE_FOLDER).pop()
            : "",
        };
        const { image, ...updatedFormData } = value;
        updateCustomerPost(updatedFormData);
      } else {
        let value = {
          ...formData,
          // companyId: formData?.companyId?.code,
          url: formData?.image
            ? formData?.image.split(process.env.REACT_APP_FILE_FOLDER).pop()
            : "",
        };
        const { image, ...updatedFormData } = value;
        createCustomerPost(updatedFormData);
      }
    } catch (error) {
      const validationErrors = {};
      error.inner.forEach((validationError) => {
        validationErrors[validationError.path] = validationError.message;
      });
      setErrors(validationErrors);
      if (Object.keys(validationErrors)[0]) {
        const inputField = document.getElementsByName(
          Object.keys(validationErrors)[0]
        );
        inputField[0].focus();
      }
    }
  };

  const { mutate: uploadImage, isLoading: imageLoading } = useMutation((file) =>
    Upload_Image(file, setdialogsModal, setFormData, FileType.SYSTEM_IMAGE)
  );

  /**
   *
   * @param {get {value} and {name}} e
   * input value change
   */

  const handleChangeCustomerPost = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
    setErrors((prev) => {
      return {
        ...prev,
        [name]: "",
      };
    });
  };

  const search = (e) => {};

  /**
   * delete company image
   */
  const { mutate: postsDelete, isLoading: isLoadingDelete } = useMutation(
    (imgData) => DELETE_IMAGE(imgData, refetch)
  );

  const accept = (imgType) => {
    let imgData = {
      fileName: formData[`${imgType}`]
        .split(`${process.env.REACT_APP_FILE_FOLDER}`)
        .pop(),
    };
    setFormData((prev) => {
      return {
        ...prev,
        [`${imgType}`]: "",
      };
    });
    postsDelete(imgData);
  };

  const openImageUploadModal = async (e, imgType) => {
    let reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.onload = (_event) => {
      setFormData((prev) => {
        return {
          ...prev,
          image: reader.result,
        };
      });
    };
    setErrors((prev) => {
      return {
        ...prev,
        ["image"]: "",
      };
    });
    await uploadImage(e.target.files[0]);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  let paramObj = useMemo(() => {
    let pramObj = {
      pageNumber: customerDrop.pageNumber,
      search: { isActive: true },
    };
    if (customerDrop.nameFilter) {
      pramObj["search"]["name"] = customerDrop.nameFilter;
    }
    return {
      ...pramObj,
      search: JSON.stringify({ ...pramObj.search }),
    };
  }, [customerDrop.pageNumber, customerDrop.nameFilter]);

  useQuery(["getCustomerDrop", paramObj], () => get_Customer(paramObj), {
    keepPreviousData: true,
    retry: 3,
    onSuccess: (response) => {
      if (response.status === 200) {
        setCustomerDrop((prev) => {
          const newData = response.payload.data.map((elem) => ({
            name: `${elem.name}`,
            value: elem.customerId,
          }));

          // Merging and filtering out duplicates based on the "value"
          const uniqueData = [
            ...prev.data,
            ...newData.filter(
              (newItem) =>
                !prev.data.some((prevItem) => prevItem.value === newItem.value)
            ),
          ];

          return {
            ...prev,
            data: uniqueData,
            totalRecords: response.pager.totalRecords,
          };
        });
      }
    },
  });

  return (
    <Fragment>
      <Dialog
        header={isEdit ? CreateCustomerPostTitle : UpdateCustomerPostTitle}
        className="modal_style"
        visible={dialog}
        position="top"
        onHide={() => handleOpenandClosePopup(false)}
        draggable={false}
        resizable={false}
      >
        <IsLoadingResponse
          isLoading={
            createCompanyLoader ||
            updateCompanyLoader ||
            isLoadingDelete ||
            imageLoading
          }
        />
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <Form
                  className="needs-validation"
                  onSubmit={(e) => handleCustomerCreateAndUpdate(e)}
                >
                  <Row>
                    <div className="field mb-4 col-12 md:col-12">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          flexWrap: "wrap",
                          marginBottom: "15px",
                        }}
                      >
                        <div
                          style={{
                            height: "150px",
                            width: "185px",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={
                              formData?.image ? formData.image : NOT_FOUND_IMAGE
                            }
                            alt=""
                            style={{
                              width: "100%",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          textAlign: "center",
                          // display: "flex",
                          // justifyContent: "center",
                          // flexWrap: "wrap",
                        }}
                      >
                        <p>{"Upload Image"}</p>
                        {!formData.image && (
                          <input
                            className="custom-file-input"
                            type="file"
                            onChange={(e) => openImageUploadModal(e)}
                          />
                        )}

                        <Button
                          className="p-button p-component p-button-outlined w-full sm:w-auto flex-order-0 sm:flex-order-1"
                          style={{ height: "40px" }}
                          type="button"
                          onClick={() => {
                            if (formData.image) {
                              SweetConfirmation(accept, "image");
                            }
                          }}
                        >
                          <span
                            className={`p-button-icon p-c p-button-icon-left pi pi-camera `}
                          ></span>
                          <span
                            className="p-button-label p-c"
                            style={{ fontWeight: "100" }}
                          >
                            {"Choose"}
                          </span>
                        </Button>
                      </div>
                      {errors.image && (
                        <p className="error-validation text-center">
                          {errors.image}
                        </p>
                      )}
                    </div>
                    <Col md="6 mb-4">
                      <FormDataFeild
                        label={"Post Title"}
                        name="postTitle"
                        id="postTitle"
                        type={TYPE_FELDS.text}
                        placeholder={"postTitle"}
                        value={formData.postTitle}
                        isValid={false}
                        handleChange={handleChangeCustomerPost}
                      />
                      {errors.postTitle && (
                        <span className="error-validation">
                          {errors.postTitle}
                        </span>
                      )}
                    </Col>
                    <Col md="6 mb-4">
                      <FormDataFeild
                        label={"Customer"}
                        name="customerId"
                        id="customerId"
                        placeholder={"Customer"}
                        value={formData.customerId}
                        handleChange={handleChangeCustomerPost}
                        dropdown={true}
                        isValid={false}
                        option={customerDrop.data}
                        search={(filter) => {
                          setCustomerDrop((prev) => {
                            return {
                              ...prev,
                              nameFilter: filter,
                              pageNumber: 1,
                            };
                          });
                        }}
                        handleScroll={() =>
                          handleInfiniteScroll({
                            cls: DROPDOWN_CLASS.SINGLE_DROP,
                            length: customerDrop.data.length,
                            setNextPage: setCustomerDrop,
                            totalR: customerDrop.totalRecords,
                          })
                        }
                      />
                      {errors.customerId && (
                        <span className="error-validation">
                          {errors.customerId}
                        </span>
                      )}
                    </Col>
                    <Col md="6 mb-4">
                      <FormDataFeild
                        label={"Post Type"}
                        name="postType"
                        id="postType"
                        placeholder={"Post Type"}
                        value={formData.postType}
                        handleChange={handleChangeCustomerPost}
                        dropdown={true}
                        option={Post_Type}
                        filter={false}
                      />
                      {errors.postType && (
                        <span className="error-validation">
                          {errors.postType}
                        </span>
                      )}
                    </Col>
                    <Col md="6 mb-4">
                      <FormDataFeild
                        label={"Schedule Date"}
                        name="scheduleDate"
                        id="scheduleDate"
                        type={TYPE_FELDS.date}
                        placeholder={"Schedule Date"}
                        value={formData.scheduleDate}
                        handleChange={handleChangeCustomerPost}
                      />
                      {errors.scheduleDate && (
                        <span className="error-validation">
                          {errors.scheduleDate}
                        </span>
                      )}
                    </Col>
                    <Col md="6 mb-4">
                      <div>
                        <label
                          htmlFor="isGeneralPost"
                          className="font-medium text-900"
                          style={{ fontSize: "14px" }}
                        >
                          {"is General Post"}
                        </label>
                      </div>
                      <InputSwitch
                        name="isGeneralPost"
                        id="isGeneralPost"
                        checked={formData.isGeneralPost === true}
                        onChange={handleChangeCustomerPost}
                      />
                    </Col>
                    <Col md="6 mb-4">
                      <div>
                        <label
                          htmlFor="isWithFrame"
                          className="font-medium text-900"
                          style={{ fontSize: "14px" }}
                        >
                          {"is With Frame"}
                        </label>
                      </div>
                      <InputSwitch
                        name="isWithFrame"
                        id="isWithFrame"
                        checked={formData.isWithFrame === true}
                        onChange={handleChangeCustomerPost}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12 mb-4" className="btn-style">
                      <Button
                        label={Submit}
                        icon="pi pi-check"
                        loading={createCompanyLoader || updateCompanyLoader}
                        type={TYPE_FELDS.submit}
                      />
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <CropImagePopup
          dialogModal={dialogModal}
          setdialogsModal={setdialogsModal}
          image={formData?.image}
          aspect={aspect}
          crop={crop}
          setCrop={setCrop}
          completedCrop={completedCrop}
          setCompletedCrop={setCompletedCrop}
          scale={scale}
          rotate={rotate}
          setFormData={setFormData}
          uploadImage={uploadImage}
        />
      </Dialog>
    </Fragment>
  );
};

export default CustomerPostCreateFormPopup;
